import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function indexStudentSkills(): Promise<ApiResponse> {
  return Axios.get("/v1/students/skills");
}
